module.exports = __webpack_public_path__ + "media/images/emblems/Avully-coat_of_arms-2e8d3134406c663fc3caf76b739ad57d.svg";